import React from 'react';
import './Steps.css';

function Step4({ onNext }) {
  return (
    <div className="step-container">
      <div className="step-content">
        <div className="emoji-large">🌹</div>
        <h1 className="step-title">Step 4 – Special Access Question</h1>
        <h2 className="heading">🔑 One Important Question</h2>
        <p className="text">"If I promise to annoy you, love you, protect you, and stand with you always…"</p>
        <p className="question">"Will you stay with me?"</p>
        <div className="button-group">
          <button className="btn btn-primary" onClick={onNext}>
            Yes 💍
          </button>
          <button className="btn btn-secondary" onClick={onNext}>
            Always ❤️
          </button>
        </div>
      </div>
    </div>
  );
}

export default Step4;